// Flotillo "Blueprint navy" design tokens — the single source of truth for colour.
// Consumed three ways:
//   1. tailwind.config.js → utility classes (bg-ink, text-muted, border-line, ...)
//   2. tailwind.config.js base plugin → :root CSS variables (var(--ink), ...) for inline styles
//   3. direct import → JS-only consumers that can't read CSS (Recharts fills, jsPDF)
// Don't add colours here without a design decision; map new needs to an existing token.

const tokens = {
  ink: '#0E1B36',       // nav bar, headings, primary dark surface
  accent: '#2F5FD8',    // primary buttons, active states
  link: '#2450C0',      // links; also primary-button hover
  ground: '#E6ECF7',    // app background (tinted so white cards stand off it)
  surface: '#FFFFFF',   // cards
  line: '#D9DFEA',      // borders (named "line" so it doesn't collide with Tailwind's border-* utilities)
  tint: '#E6ECFB',      // icon chips, selected rows
  text: '#111827',
  muted: '#4B5563',
  faint: '#5B6472',
  onDark: '#8FB0FF',    // active-tab underline and eyebrow text on navy
  tableHead: '#F2F4F8', // table header background

  // Status pills — keep exactly these.
  critBg: '#FCEBEB', critText: '#A32D2D',                     // Critical / At risk
  watchBg: '#FAEEDA', watchText: '#854F0B', watchBorder: '#EBD9B6', // Watch / Stale
  okBg: '#EAF3DE', okText: '#3B6D11',                          // On track

  // Status edges — the coloured left border on Portfolio project cards/rows.
  edgeCrit: '#E63946', edgeWatch: '#D9A441', edgeOk: '#3B6D11',

  // Logo-only — never UI chrome.
  logoNavy: '#0B1F3A', logoLight: '#F7F8FB', logoRed: '#E63946',
};

// CSS custom-property names (camelCase → kebab-case): onDark → --on-dark, tableHead → --table-head-bg.
// The spec's names win where they differ from the Tailwind key: line → --border, tableHead → --table-head-bg.
const CSS_VAR_OVERRIDES = { line: '--border', tableHead: '--table-head-bg' };
const cssVarName = (key) => CSS_VAR_OVERRIDES[key] ?? '--' + key.replace(/[A-Z]/g, (c) => '-' + c.toLowerCase());

module.exports = { tokens, cssVarName };
